"use client";
import Link from "next/link";
import React from "react";
import Button from "../ui/Button";
import useAuthInfo from "@/store/auth";
import Profile from "../partials/header/Tools/Profile";
import { Icon } from "@iconify/react";
import { usePathname } from "next/navigation";

export default function DesktopNavLinks() {
  const userData = useAuthInfo((state) => state);
  const currentPath = usePathname();

  return (
    <div className="absolute right-0 flex flex-row space-x-6 justify-center items-center">
      <ul className="flex flex-row items-center text-center gap-4">
        <Link href="/download" className={`${currentPath.includes("download") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0 ">Download</li>
        </Link>
        <Link href="/campaigns" className={` ${currentPath.includes("campaigns") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0">Campaigns</li>
        </Link>
        <Link href="/discover" className={` ${currentPath.includes("discover") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0">Discover</li>
        </Link>
        {/* <Link href="/supply" className={`${currentPath.includes("supply") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0">Supply</li>
        </Link> */}
        {/* <Link href="/referral" className={`${currentPath.includes("referral") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0">Earn</li>
        </Link> */}
        {/* <Link href="/stokvels" className={`${currentPath.includes("stokvels") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0">Stokvel</li>
        </Link> */}
        <Link href="/blog" className={`${currentPath.includes("blogs") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
          <li className="border-b md:border-b-0">Blogs</li>
        </Link>
        {!userData.apiToken && (
          <>
            <Link href="/login" >
              <li className="bg-transparent">Login</li>
            </Link>
            <Link href="/register">
              <li className="bg-transparent border-stone-600 border-2 rounded-full py-3 px-4">
                Sign Up
              </li>
            </Link>
          </>
        )}
        {userData.apiToken && (
          <>
            <Link href="/portfolio" className={`${currentPath.includes("portfolio") ? "bg-primary-500 p-2 rounded-md text-white" : ""}`}>
              <li >Portfolio</li>
            </Link>
            <div className="flex items-center">
              <Profile />
            </div>
          </>
        )}
      </ul>
    </div>
  );
}
